import React from "react";
import { useTranslation } from "hooks";
import { translations } from "./translations";

export const InHomolog: React.FC = () => {
  const { getTranslation } = useTranslation(translations);

  return (
    <div className="bg-orange-500 text-white text-center py-2 font-GilroySemibold">
      {getTranslation("text")}
    </div>
  );
};
